var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C20.2091 0 22 1.79086 22 4V5.00293C23.1101 5.036 24 5.94434 24 7.0625V11.9375L23.9893 12.1484C23.8857 13.168 23.0394 13.9651 22 13.9961V16C22 18.2091 20.2091 20 18 20H4C1.79086 20 0 18.2091 0 16V4C0 1.79086 1.79086 0 4 0H18ZM4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H18C19.1046 18 20 17.1046 20 16V14H17.5C15.0147 14 13 11.9853 13 9.5C13 7.09234 14.8908 5.12632 17.2686 5.00586L17.5 5H20V4C20 2.89543 19.1046 2 18 2H4ZM17.5 7C16.1193 7 15 8.11929 15 9.5C15 10.8807 16.1193 12 17.5 12H21.9375C21.9496 12 21.9563 11.998 21.9609 11.9961C21.967 11.9935 21.9743 11.9886 21.9814 11.9814C21.9886 11.9743 21.9935 11.967 21.9961 11.9609C21.998 11.9563 22 11.9496 22 11.9375V7.0625C22 7.05044 21.998 7.04375 21.9961 7.03906C21.9935 7.03303 21.9886 7.02566 21.9814 7.01855C21.9743 7.01145 21.967 7.00646 21.9609 7.00391C21.9563 7.00196 21.9496 7 21.9375 7H17.5ZM17.5 8C18.3284 8 19 8.67157 19 9.5C19 10.3284 18.3284 11 17.5 11C16.6716 11 16 10.3284 16 9.5C16 8.67157 16.6716 8 17.5 8Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.51edc8a6cb118d02a29b2f2875ffc8c5.svg";
export { ForwardRef as ReactComponent };